module.exports = __webpack_public_path__ + "static/paidy-card-2-2153993f2b3d21d48651cf3fcbff019f.png";